module.exports = __webpack_public_path__ + "img/img5.9727c5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img5.jpg
// module id = 300
// module chunks = 0